module.exports = __webpack_public_path__ + "img/padlock.9de14f50.svg";